import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-remove-round",
  "use": "svg_i-remove-round-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"svg_i-remove-round\"><path d=\"M15.24 2.76c-3.445-3.443-9.035-3.443-12.48 0-3.443 3.445-3.443 9.035 0 12.48 3.445 3.443 9.035 3.443 12.48 0 3.443-3.445 3.443-9.035 0-12.48zm-3.744 9.984L9 10.248l-2.496 2.496-1.248-1.248L7.752 9 5.256 6.504l1.248-1.248L9 7.752l2.496-2.496 1.248 1.248L10.248 9l2.496 2.496-1.248 1.248z\" fill=\"currentColor\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol